import * as React from 'react';
import { defaultUnifySeverities } from 'src/components/TextField/useUnifySeverity';

type ActionBasePlacement = 'inline' | 'footer';

export const unifyAlertBaseSeverities = [
  ...defaultUnifySeverities,
  'info',
] as const;
export type UnifyAlertBaseSeverity = (typeof unifyAlertBaseSeverities)[number];

export type IAlertBaseContext = {
  /**
   * The severity which defines the color and icon displayed to the user.
   *
   * @default 'info'
   */
  severity?: UnifyAlertBaseSeverity;

  /**
   * The alignment of the action(s).
   *
   * 'footer' will render the action below the content and onClose button.
   *
   * @default 'inline'
   */
  actionPlacement?: ActionBasePlacement;
};

export const defaultAlertBaseContextValue = {
  severity: 'info',
  actionPlacement: 'inline',
} as const satisfies Required<IAlertBaseContext>;

const AlertBaseContext = React.createContext<Required<IAlertBaseContext>>(
  defaultAlertBaseContextValue
);

export const AlertBaseContextProvider = AlertBaseContext.Provider;

/**
 * @access package
 */
export const useAlertBaseSeverity = (): NonNullable<
  IAlertBaseContext['severity']
> => React.useContext(AlertBaseContext).severity;
